export const toQueryString = (queryObject) => Object.keys(queryObject)
    .map(key => `${key}=${encodeURIComponent(queryObject[key])}`)
    .join('&');
//# sourceMappingURL=urlUtils.js.map